var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarouselArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.10485L1.10485 0L10.251 9.14618L1.10485 18.2924L0 17.1875L8.04071 9.14618L0 1.10485Z",
    fill: "#1A1D21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselArrowRight);
export default __webpack_public_path__ + "static/media/Carousel-arrow-right.b08edf0689d7ddd3bc3f6293e263c4ad.svg";
export { ForwardRef as ReactComponent };